export const Organization_API = {
    organizationHistory: {uploadCSV}
}

function uploadCSV(orgId,verCenterId, historyId) {
    return {api: `/api/v2/organizations/${orgId}/verificationCenters/${verCenterId}/histories/${historyId}`, method: 'POST'}
}